<template>
    <header class="h-8 flex flex-shrink-0 justify-between items-center mb-5 | 2xl:mb-6">
        <div class="flex items-baseline">
            <component
                :is="tag"
                class="text-3xl"
                :class="{ 'hover:text-blue-500': isLink }"
                :to="to"
                v-text="title"
            />
            <template v-if="subtitle">
                <nio-icon class="mx-2 text-base" name="regular/arrow-right-1" />
                <h4 class="text-2xl" v-text="subtitle" />
            </template>
        </div>

        <div class="flex items-center space-x-2">
            <slot>
                <nio-button class="invisible">
                    I am but a ghost. Hiding in plain sight.
                </nio-button>
            </slot>
        </div>
    </header>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true,
            },
            subtitle: {
                type: String,
                default: '',
            },
            to: {
                type: [String, Object],
                default: '',
            },
        },

        computed: {
            isLink() {
                return !!this.to;
            },

            tag() {
                return this.isLink ? 'router-link' : 'span';
            },
        },
    };
</script>
